module.exports = __webpack_public_path__ + "static/media/Sudan-Map.59621a09.svg";